import styles from "./styles.module.css";

export default PageShabibi;

const apps = [
   {
      name: "Scan and Speak",
      desc: "Scan books and texts and let the app speak it to you.",
      icon: "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/58/ab/fa/58abfa23-f6b9-5855-98d0-946497079e56/AppIcon-0-0-1x_U007emarketing-0-9-0-85-220.png/512x512bb.jpg",
      appStore: "https://apps.apple.com/app/scan-and-speak-easy-reading/id1631151308",
   },
   {
      name: "Drum Trainer",
      desc: "Learn beats fast, create your own, or try beats made by others!",
      icon: "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/6b/90/2c/6b902c0c-0851-ffda-580e-8e472f7bc23e/AppIcon-0-0-1x_U007emarketing-0-8-0-85-220.png/512x512bb.jpg",
      appStore: "https://apps.apple.com/app/drum-trainer/id1578345647",
      googlePlay: "https://play.google.com/store/apps/details?id=com.userh309.drum.trainer",
   },
   {
      name: "Feed Me Weather",
      desc: "A simple, clean weather app for your location.",
      icon: "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/00/f5/59/00f559d0-33fa-5cfa-2144-891d5c931727/AppIcon-0-0-1x_U007emarketing-0-8-0-85-220.png/512x512bb.jpg",
      appStore: "https://apps.apple.com/app/feed-me-weather/id1367370824",
   },
   {
      name: "Feed Your Giant",
      desc: "Feed the giant with hamburgers, keep him satisfied. Bring your best throwing skills and get your name on the global leaderboard!",
      icon: "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/7b/e7/b6/7be7b695-98c3-900a-ba74-ea40296b9203/AppIcon-0-0-1x_U007emarketing-0-8-0-85-220.png/512x512bb.jpg",
      appStore: "https://apps.apple.com/app/feed-your-giant/id1638582750",
   },
   {
      name: "Line Timer",
      desc: "Type your steps, add a time, press play.",
      icon: "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/6f/5c/c5/6f5cc56d-97e2-987d-0cdb-3ae33a3da224/AppIcon-0-0-1x_U007epad-0-1-85-220.png/512x512bb.jpg",
      appStore: "https://apps.apple.com/app/line-timer/id6759217994",
   },
];

function PageShabibi() {
   return (
      <div>
         {apps.map((app, i) => (
            <div key={i} className={styles.appRow}>
               <img src={app.icon} alt={app.name} className={styles.appIcon} />
               <div className={styles.appInfo}>
                  <b>{app.name}</b>
                  <br />
                  {app.desc}
                  <br />
                  <a href={app.appStore} target="_blank" rel="noopener noreferrer">App Store</a>
                  {app.googlePlay && (
                     <>
                        {" | "}
                        <a href={app.googlePlay} target="_blank" rel="noopener noreferrer">Google Play</a>
                     </>
                  )}
               </div>
            </div>
         ))}
      </div>
   );
}
